import { render, staticRenderFns } from "./documents_navigation.vue?vue&type=template&id=05386b4a"
import script from "./documents_navigation.vue?vue&type=script&lang=js"
export * from "./documents_navigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports